import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import moment from 'moment';
import momentJalaali from 'moment-jalaali';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
// import moment from 'moment';
// import momentJalaali from 'moment-jalaali';

declare let $: any;

@Component({
  selector: 'Income',
  templateUrl: './Income.component.html',
})
export class IncomeComponent implements OnInit {
  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    public otherService: OtherService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private _location: Location,
    private gurdService: GurdServiceService
  ) { }
  Id: number = 0;
  Income: any;
  totalIncomde: number = 0;
  EditeMod: boolean = false;
  datatTa: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  dataAz: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  datasabt: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  serchModel: FormGroup = this.formBuilder.group({
    strComment: new FormControl(),
  });

  sabtModel: FormGroup = this.formBuilder.group({
    iAmount: new FormControl(),
    strComment: new FormControl(''),
    iCarRvenues: new FormControl(),
  });
  ngOnInit(): void {
    $('#exampleModal').on('hidden.bs.modal', () => {
      this.close();
    });
    this.route.params.subscribe((params) => {
      this.Id = params['id'];
    });
    this.getAllIncom();
    var d = new Date();
    d.setMonth(d.getMonth() - 1);

    // d.toLocaleDateString('fa-IR-u-nu-latn');
    // var m=moment(`${d.toLocaleDateString('fa-IR-u-nu-latn')}`, 'jYYYY/jMM/jDD').format('YYYY/MM/DD');

    this.dataAz.reset({
      date: moment(`${d.toLocaleDateString('fa-IR-u-nu-latn')}`, 'jYYYY/jMM/jDD').format('YYYY/MM/DD'),
    });

  }
  seprator(e: any) {
    if (isNaN(e.key)) {
      return false;
    }
    this.otherService.insertComma(e);
    return true;
  }
  goBack() {
    this._location.back();
  }
  getAllIncom = async (
    strSDate?: string,
    strEDate?: string,
    strComment?: string
  ) => {
    var model = {
      strUnitID: this.Id,
      strSDate: `${strSDate == undefined ? '' : strSDate}`,
      strEDate: `${strEDate == undefined ? '' : strEDate}`,
      strComment: `${strComment == undefined ? '' : strComment}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    };

    const resp = await axios.post(
      `GetCarRvenuessNew`,
      model
    );

    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '101' } });

      return;
    }


    if (resp.data.length == 0) {
      this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
      this.Income = resp.data;
    }

    else {
      this.Income = resp.data;
      this.Income.forEach((element: any) => {
        this.totalIncomde += element.iAmount;
      });

    }

  };
  sabt = async () => {

    var model = this.sabtModel.value;

    model.strDate = this.datasabt.value.date;

    model.strUnitId = this.Id;

    if (model.iAmount == null || model.iAmount == '' || model.iAmount <= 0) {
      this.notifyService.showError('لطفا مقدار هزینه را وارد کنید');
      return;
    }

    model.iAmount = parseFloat(model.iAmount.replace(/,/g, ''));

    if (confirm('آیا از ثبت اطلاعات اطمینان دارید؟')) {

      const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));

      const resp = await axios.post(`SaveCarRvenues?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`, model);

      if (resp.data == -100) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
        return;
      }
      if (resp.data == 0) {
        this.notifyService.showError('خطایی رخ داده');
      }
      if (resp.data == 1) {
        this.notifyService.showSuccess('با موفقیت ثبت شد');
        this.getAllIncom();
        $('#exampleModal').modal('hide');
      }
    }

  };
  serch() {
    var model = this.serchModel.value;
    this.getAllIncom(
      this.dataAz.value.date,
      this.datatTa.value.date,
      model.strComment
    );
  }
  getSingel = async (Id: any) => {
    this.datasabt.controls['date'].setValue(this.Income[Id].strDate);
    this.sabtModel.controls['strComment'].setValue(this.Income[Id].strComment);
    this.sabtModel.controls['iAmount'].setValue(
      this.Income[Id].iAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
    this.sabtModel.controls['iCarRvenues'].setValue(
      this.Income[Id].iCarRvenues
    );
    $('#exampleModal').modal('show');
    this.EditeMod = true;
  };
  edit = async () => {
    var model = this.sabtModel.value;

    model.strDate = this.datasabt.value.date;
    model.strUnitId = this.Id;
    if (model.iAmount == null || model.iAmount == '' || model.iAmount <= 0) {
      this.notifyService.showError('لطفا مقدار هزینه را وارد کنید');
      return;
    }

    model.iAmount = parseFloat(model.iAmount.replace(/,/g, ''));
    //model.iAmount= model.iAmount.replace(/,(?=\d{3})/g, '');
    if (confirm('آیا از ویرایش اطلاعات اطمینان دارید؟')) {
      const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));
      const resp = await axios.post(
        `EditCarRvenues?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
        model
      );
      if (resp.data == -100) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
        return;
      }
      if (resp.data == 0) {
        this.notifyService.showError('خطایی رخ داده');
        this.sabtModel.reset();
      }
      if (resp.data == 1) {
        this.notifyService.showSuccess('با موفقیت ثبت شد');
        this.getAllIncom();
        $('#exampleModal').modal('hide');
      }
    }
  };
  deleteIncom = async () => {
    if (confirm('آیا از حذف اطلاعات اطمینان دارید؟')) {
      var Id = this.sabtModel.value.iCarRvenues;
      var model = {
        iCarRvenues: Id,
      };

      const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));

      const resp = await axios.post(
        `DeleteCarRvenues?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
        model
      );
      if (resp.data == -100) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
        return;
      }
      if (resp.data == -1) {
        this.notifyService.showError('خطایی رخ داده');
        this.sabtModel.reset();
      }
      if (resp.data == 1) {
        this.notifyService.showSuccess('با موفقیت حذف شد');
        $('#exampleModal').modal('hide');

        this.Income = this.Income.filter(function (el: any) {
          return el.iCarRvenues != Id;
        });
      }
    }
  };
  close() {
    this.sabtModel.reset({
      strComment: '',
    });
    this.datasabt.reset({
      date: momentJalaali().format('jYYYY/jMM/jDD'),
    });
    this.EditeMod = false;
  }
  open() {
    this.close();
  }
  guid(Id: any) {
    this.otherService.guid(Id);
  }
}
